import api from "./axios";
import type { Company, PaginatedResponse, Review } from "@/types";
import { ApiPath } from "@/constants/api-routes";

export const companiesApi = {
  getAll: (skip = 0, limit = 50) =>
    api
      .get<PaginatedResponse<Company>>(ApiPath.companies(), {
        params: { skip, limit },
      })
      .then((r) => r.data),

  getById: (id: string) => api.get<Company>(ApiPath.company(id)).then((r) => r.data),

  getReviews: (companyId: string, skip = 0, limit = 50) =>
    api
      .get<PaginatedResponse<Review>>(ApiPath.companyReviews(companyId), {
        params: { skip, limit },
      })
      .then((r) => r.data),
};
